<ion-app class="app-background">
  @if (isReady) {
    <app-loader [visible]="loading" [message]="'loading-service.please-wait' | translate"></app-loader>
  }
  @if (isReady) {
    <ion-split-pane contentId="main-content" when="always" [attr.aria-busy]="loading ? 'true' : null">
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
  }
</ion-app>